/**
 * Return string of first letters of each argument
 * @param parts
 */
export const getFirstLetters = (...parts: Array<string | undefined>): string => {
  return parts.reduce((result: string, part) => {
    return part ? result + part.charAt(0) : result;
  }, '');
};
